import { render, staticRenderFns } from "./PillLauncher.vue?vue&type=template&id=36a5c5bc&scoped=true&"
import script from "./PillLauncher.vue?vue&type=script&lang=js&"
export * from "./PillLauncher.vue?vue&type=script&lang=js&"
import style0 from "./PillLauncher.vue?vue&type=style&index=0&id=36a5c5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5c5bc",
  null
  
)

export default component.exports